var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"tw-rounded-full tw-object-cover",style:({
    width: `${_vm.size}px`,
    height: `${_vm.size}px`,
  }),attrs:{"src":_setup.currentSrc,"alt":"foto de perfil"},on:{"error":_setup.handleError}})
}
var staticRenderFns = []

export { render, staticRenderFns }